import { MutationTuple, useMutation } from '@apollo/client';

import {
  UnlinkTicketingProviderUserFromRdTaxCreditContributorMutation,
  UnlinkTicketingProviderUserFromRdTaxCreditContributorMutationVariables,
  UNLINK_TICKETING_PROVIDER_USER_FROM_RD_TAX_CREDIT_CONTRIBUTOR,
} from '@neo.tax/shared';

type UseUnlinkTicketingProviderUserFromRdTaxCreditContributor = MutationTuple<
  UnlinkTicketingProviderUserFromRdTaxCreditContributorMutation,
  UnlinkTicketingProviderUserFromRdTaxCreditContributorMutationVariables
>;

export const useUnlinkTicketingProviderUserFromRdTaxCreditContributor =
  (): UseUnlinkTicketingProviderUserFromRdTaxCreditContributor =>
    useMutation<
      UnlinkTicketingProviderUserFromRdTaxCreditContributorMutation,
      UnlinkTicketingProviderUserFromRdTaxCreditContributorMutationVariables
    >(UNLINK_TICKETING_PROVIDER_USER_FROM_RD_TAX_CREDIT_CONTRIBUTOR, {
      context: {
        successToast: {
          title: 'Account successfully unlinked',
        },
        errorToast: {
          title: 'Error unlinking account',
          description: 'Something unexpected prevented your changes from saving. Please try again.',
        },
      },
    });
